import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { deleteAdminWork } from '../../../../../../../../../store/actions/adminWork-actions';
import { IAdminWork } from '../../../../../../../../../types/adminWork';

interface Props {
    data: Partial<IAdminWork>;
}

const DeleteAdminWorkAction: React.FunctionComponent<Props> = ({ data: { id } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };

    return (
        <>
            <button
                className="btn btn-secondary  border-0"
                type="button"
                style={{ minWidth: '41px' }}
                onClick={() => setOpened(true)}
            >
                <FontAwesomeIcon icon={faTrash} />
                <span></span>
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this Admin Work?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deleteAdminWork(id ? id : 1, handleClose, (errorMessage: string) => {
                                    handleClose();
                                    toast.error(errorMessage);
                                }),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteAdminWorkAction;
